<script module lang="ts">
    import { get } from "svelte/store"

    const vat = defaultVAT
    let _preselectedDealerNumbers = $state(
        get(preselectedDealerNumber)
            ?.split(",")
            ?.map((n) => {
                return parseInt(n)
            })
    )
    // wtf
</script>

<script lang="ts">
    import { _ } from "svelte-i18n"
    import { onMount } from "svelte"
    import { iframeView, preselectedDealerNumber, referrer } from "../../../functionTools/iframeIntegration"
    import { colorGroup1, defaultVAT, maxInputLength } from "../../../../../api/hooks/config-client"
    import { login } from "../../../functionTools/login"
    import {
        cryptchaSolution,
        cryptchaSolutionId,
        cryptchaStep,
        formatPrice,
        getProductOption,
        getProductPrice,
        initCryptcha,
        resetCryptcha,
    } from "../../../utils"
    import { setUser } from "../../../sentry"
    import BarLoader from "svelte-loading-spinners/BarLoader.svelte"
    import FormInputText from "../../widgets/Form/FormInputText.svelte"
    import {
        getCountry,
        getDealer,
        postOfferAssistantInquiry,
        postOfferAssistantTrackingEvent,
        postProductInquiry,
    } from "../../../api"
    import ProductSummary from "./productInquiry/ProductSummary.svelte"
    import { inquiry } from "../../../functionTools/offerAssistant"
    import AddressForm from "./productInquiry/AddressForm.svelte"
    import ContactForm from "./productInquiry/ContactForm.svelte"
    import CustomerType from "./productInquiry/CustomerType.svelte"
    import DealerChoice from "./productInquiry/DealerChoice.svelte"
    import StoreChoice from "./productInquiry/StoreChoice.svelte"
    import { getCartSum } from "./productInquiry/helper"
    import { truncateFields } from "../../routes/checkout/helper"
    import CryptchaS5 from "../../widgets/CryptchaS5.svelte"
    import { overlay, staticFrontendLinks } from "../../../store"
    import { initialLocale } from "../../../i18n"

    let loading = $state(false)
    let success = $state(false)

    let {
        product,
        activeColor = undefined,
        activeOptions = [],
        offerAssistantConfiguration,
        submitInquirySuccessCallback = () => {},
    }: ProductInquiryProps = $props()

    let selectedCountry: Country = $state()
    let oldCode: string = $state(null)
    $effect(() => {
        if ($inquiry.billingAddress) {
            let code = $inquiry.billingAddress.countryCode
            if (oldCode != code) {
                getCountry($inquiry.billingAddress.countryCode).then((c) => {
                    selectedCountry = c
                })
            }
        } else {
            selectedCountry = null
            oldCode = null
        }
    })

    if ($preselectedDealerNumber && !$login) {
        getDealer({ dealerNumber: _preselectedDealerNumbers })
            .then(function (r) {
                if (r?.data?.length) {
                    $inquiry.dealerChoice = Object.assign({}, r.data[0], {
                        number: parseInt(r.data[0].number),
                    })
                }
            })
            .finally(function () {
                if (!$inquiry.dealerChoice?.number) {
                    $preselectedDealerNumber = null
                    _preselectedDealerNumbers = null
                }
            })

        $inquiry.customerType = "end"
    }
    if ($login?.account?.ident?.dealerNumber) {
        $inquiry.dealerChoice = {
            number: $login.account.ident.dealerNumber,
            postcode: null,
            company: null,
        }
    }

    let submitTried = $state(false)
    let missingDealer = $derived(
        (!$inquiry.dealerChoice || !$inquiry.dealerChoice.number) && !$inquiry.desiredRetailPartner
    )

    $effect(() => {
        if (product) {
            const cartItem: CartItem = {
                quantity: 1,
                product,
                options: product?.options?.filter((o) => activeOptions?.indexOf(o?.option) != -1),
                price: {
                    base: formatPrice(
                        $login ? product?.price_net_dealer : product?.price_net_end_customer,
                        0,
                        1,
                        false
                    ) as number,
                    options: 0,
                    unit: getProductPrice(product, !!$login, activeColor, activeOptions),
                },
            }

            if (activeColor) {
                const ralOption = getProductOption(product, "ral")
                if (ralOption) {
                    if (!cartItem.options) cartItem.options = []
                    const ralChoice: OptionEntry = {
                        option: "ral",
                        code: parseInt(activeColor.RAL),
                        price_net: 0,
                    }
                    let inGroup1 = false
                    colorGroup1.forEach((c) => {
                        if (c.RAL == activeColor.RAL) inGroup1 = true
                    })
                    if (!inGroup1) ralChoice.price_net = ralOption.price_net

                    cartItem.options.push(ralChoice)
                }
            }

            cartItem.options?.forEach((o) => {
                cartItem.price.options = formatPrice(cartItem.price.options + o.price_net, 0, 1, false) as number
            })

            const cart = [cartItem]
            $inquiry.cart = cart
            $inquiry.sum = getCartSum(cart, vat)
        }

        if (!product && offerAssistantConfiguration) {
            $inquiry.offerAssistant = offerAssistantConfiguration
        }
    })

    let x = ""

    function getOfferAssistantTrackingData() {
        return {
            configurationName: offerAssistantConfiguration?.configurationName || offerAssistantConfiguration?.id,
            customerType: $inquiry.customerType || undefined,
            iframe: $iframeView,
            preselectedDealer: !!$preselectedDealerNumber,
            dealerSelected: !!$inquiry.dealerChoice?.number,
            countryCode: $inquiry.billingAddress?.countryCode || undefined,
        }
    }

    async function submit() {
        setUser({
            username:
                $login?.account?.ident && $login.account.ident.dealerNumber + "-" + $login.account.ident.personNumber,
            email: $inquiry.contact?.email,
        })

        submitTried = true

        const shouldSubmit =
            !missingDealer ||
            !(selectedCountry.show_inquiry_local_store_select || selectedCountry.show_inquiry_online_shop_select)

        if (shouldSubmit) {
            loading = true

            try {
                $inquiry._s = $cryptchaSolution
                $inquiry._sId = $cryptchaSolutionId

                if ($login) {
                    $inquiry.billingAddress = {}
                    $inquiry.customerType = null
                    $inquiry.account = $login.account
                    $inquiry.contact = {}
                }

                $inquiry.contact = truncateFields($inquiry.contact, maxInputLength)
                $inquiry.billingAddress = truncateFields($inquiry.billingAddress, maxInputLength)
                $inquiry.deliveryAddress = truncateFields($inquiry.deliveryAddress, maxInputLength)
                const checksum = ((($inquiry.contact?.email?.length as number) || 1) * 1000).toString(16) + x

                if (product) await postProductInquiry($inquiry, checksum)
                if (!product && offerAssistantConfiguration) {
                    postOfferAssistantTrackingEvent("offerAssistantSubmitAttempt", getOfferAssistantTrackingData()).catch(
                        (error) => {
                            console.error("Failed to post offer assistant submit attempt event", error)
                        }
                    )
                    await postOfferAssistantInquiry($inquiry, checksum)
                    submitInquirySuccessCallback()
                }
                success = true
            } catch (e) {
                if ((e as any).data?.status == 403) {
                    alert($_("inquiry.error-alert"))
                } else {
                    alert($_("inquiry.error-alert"))
                    throw new Error(JSON.stringify(e, null, 4))
                }
            } finally {
                loading = false
                resetCryptcha()
            }
        }
    }

    typeof window !== "undefined" &&
        window.setTimeout(() => {
            x = "x"
        }, 5000)

    onMount(() => initCryptcha())

    let oldDealerNumber = $state($inquiry.dealerChoice?.number)
    $effect(() => {
        if (oldDealerNumber !== $inquiry.dealerChoice?.number && $inquiry.dealerChoice?.number) {
            oldDealerNumber = $inquiry.dealerChoice?.number
            $inquiry.desiredRetailPartner = ""
        }
    })

    let _dealerChoiceQuery: {
        countrycode: string
        postcode: string
        dealerNumber: string | number | string[] | number[]
        range: number
        online?: boolean
    } = $state(null)
    let _oldCountryCode: string = $state(null)
    let _oldPostcode: string = $state(null)
    let _oldDealerNumbers: number[] = $state(null)

    $effect(() => {
        if (
            _oldCountryCode !== $inquiry.billingAddress.countryCode ||
            (_oldPostcode !== $inquiry.billingAddress.postcode && $inquiry.billingAddress.postcode.length == 5) ||
            JSON.stringify(_oldDealerNumbers) !== JSON.stringify(_preselectedDealerNumbers)
        ) {
            _oldCountryCode = $inquiry.billingAddress.countryCode
            _oldPostcode = $inquiry.billingAddress.postcode
            _oldDealerNumbers = _preselectedDealerNumbers
            _dealerChoiceQuery = {
                countrycode: $inquiry.billingAddress.countryCode,
                postcode: $inquiry.billingAddress.countryCode == "DE" ? $inquiry.billingAddress?.postcode : null,
                dealerNumber: _preselectedDealerNumbers,
                range: 10000,
            }
        }
    })

    $effect(() => {
        if ($preselectedDealerNumber && $inquiry.referrer.preselectedDealerNumber !== $inquiry.dealerChoice?.number)
            $inquiry.referrer.preselectedDealerNumber = $inquiry.dealerChoice?.number
    })
</script>

<div class="content" class:iframe={$iframeView}>
    {#if product}
        <ProductSummary {product} color={activeColor} options={activeOptions} />
    {/if}

    <div class="header">
        {#if success && offerAssistantConfiguration}
            <h3>{$_("inquiry.success-headline-offer-assistant")}</h3>
        {:else}
            <h3>{$_("inquiry.headline")}</h3>
        {/if}
    </div>

    {#if loading}
        <BarLoader />
    {:else if success}
        {#if offerAssistantConfiguration}
            {$_("inquiry.success-offer-assistant")}
        {:else}
            {$_("inquiry.success")}
        {/if}
    {:else}
        <form
            onsubmit={(e) => {
                e.stopPropagation()
                e.preventDefault()
                submit()
            }}
        >
            <div class="leftForm">
                <section>
                    {#if !$preselectedDealerNumber && !$login}
                        <CustomerType />
                    {/if}
                    {#if !$login}
                        <div class="row">
                            <AddressForm />
                        </div>
                    {/if}
                    <div class="row">
                        <ContactForm />
                        <div class="col-md-6">
                            <FormInputText
                                name="commission"
                                label="{$_('inquiry.commission')} ({$_('inquiry.optional')})"
                                bind:value={$inquiry.commission}
                                type="text"
                                maxlength={maxInputLength.commission}
                            />
                        </div>
                        <div class="col-md-6">
                            <FormInputText
                                name="constructionProject"
                                label="{$_('inquiry.construction-project')} ({$_('inquiry.optional')})"
                                bind:value={$inquiry.constructionProject}
                                type="text"
                                maxlength={maxInputLength.constructionProject}
                            />
                        </div>
                        <div class="col-md-12">
                            <label for="">{$_("inquiry.special-request")}</label>
                            <textarea
                                name="kommentar"
                                placeholder={$iframeView
                                    ? $_("inquiry.special-request-placeholder-iframe")
                                    : $_("inquiry.special-request-placeholder")}
                                rows="5"
                                bind:value={$inquiry.comment}
                            ></textarea>
                        </div>
                    </div>
                </section>
            </div>

            <div class="rightForm">
                {#if $preselectedDealerNumber && _preselectedDealerNumbers?.length == 1}
                    <section>
                        <p>
                            {$_("inquiry.dealer-preselected-intro")}
                        </p>
                        {$inquiry.dealerChoice?.company}
                    </section>
                {:else if $preselectedDealerNumber && _preselectedDealerNumbers?.length > 1}
                    {#key _dealerChoiceQuery}
                        <DealerChoice bind:_dealerChoiceQuery />
                    {/key}
                {:else if $login}
                    <section>
                        <p>
                            {$_("inquiry.dealer-preselected-login-intro")}
                        </p>
                        {$inquiry.dealerChoice?.number}
                    </section>
                {:else if selectedCountry?.show_inquiry_local_store_select || selectedCountry?.show_inquiry_online_shop_select}
                    <StoreChoice {missingDealer} {selectedCountry} {submitTried} />
                {/if}

                <section>
                    <div class="privacyText">
                        <input type="checkbox" name="dsgvo" required />
                        {@html $_("inquiry.i-have-the")}
                        <a
                            href="/service/datenschutz"
                            onclick={(e) => {
                                e.preventDefault()
                                $overlay = {
                                    show: true,
                                    type: "content",
                                    properties: {
                                        // @ts-ignore
                                        pageToRender: $staticFrontendLinks["dataProtection"][initialLocale],
                                    },
                                }
                            }}
                        >
                            {@html $_("inquiry.data-privacy-by-renz")}
                        </a>
                        {@html $_("inquiry.data-privacy-note")}
                    </div>

                    <div class="row" style="margin-top:30px;">
                        <div class="col-md-4">
                            <button class="button primary" type="submit" disabled={!$cryptchaSolution}>
                                {$_("inquiry.send")}
                            </button>
                        </div>
                        <div class="col-md-8">
                            <CryptchaS5 {...$cryptchaStep} />
                        </div>
                    </div>
                </section>
            </div>
        </form>
    {/if}
</div>

<style lang="less">
    @import "../../../css/variables.less";

    .content {
        padding: 20px 20px 60px 20px;
    }
    .header {
        .flex();
        align-items: center;
        justify-content: space-between;
        margin-bottom: 30px;
    }
    h3 {
        margin: 0px;
        margin-bottom: 0px;
    }

    section {
        padding: 20px 0px;
        border-bottom: 1px solid var(--border-color-default);
    }

    :global .radio_group {
        .flex();
        .inputholder {
            margin-right: 20px;
        }
    }
    :global input,
    textarea {
        margin-bottom: 0px;
    }
    :global input:disabled {
        background: var(--comp--input--disabled--background);
    }

    :global .inputholder input[type="checkbox"]:checked ~ label:before {
        background: var(--primary) !important;
    }
    :global .inputholder label:before {
        border-color: var(--primary) !important;
    }
    :global .inputholder input[type="radio"]:checked ~ label:after {
        background: var(--primary) !important;
    }

    :global div.radiusChoice {
        display: flex;
        gap: 30px;
    }

    :global .content.iframe {
        &.content {
            padding: 20px 20px 60px 20px;
        }
        .header {
            .flex();
            align-items: center;
            justify-content: space-between;
            margin-bottom: 30px;
        }
        h3 {
            margin: 0px;
            margin-bottom: 0px;
        }
        section {
            padding: 20px 0px;
            border-bottom: 1px solid var(--border-color-default);
        }
        :global .section_headline {
            font-size: 1.2rem;
            margin-bottom: 15px;
        }
        .header {
            position: absolute;
            top: 14px;
            left: 55px;
        }
        .leftForm {
            width: 100%;
            float: left;
            padding-right: 30px;
            .col-md-3,
            .col-md-4,
            .col-md-5,
            .col-md-6,
            .col-md-12 {
                padding: 5px;
            }
        }
        .rightForm {
            width: 100%;
        }
    }
    @media (min-width: 1100px) {
        :global .iframe {
            .leftForm {
                width: 50% !important;
            }
            .rightForm {
                width: 50% !important;
                float: right;
                padding-left: 20px;
                border-left: 1px solid #ccc;
                .privacyText {
                    font-size: 0.7em;
                }
            }
        }
    }
</style>
